import { render, staticRenderFns } from "./menu_section.vue.js?vue&type=template&id=61ad7366!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./menu_section.vue?vue&type=template&id=61ad7366"
import script from "./menu_section.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./menu_section.vue?vue&type=script&lang=js"
export * from "./menu_section.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./menu_section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports